import { Check, X } from 'lucide-react'
import type { BinaryIncentivationDataModel, ManualInputIncentivationDataModel, ScoreIncentivationDataModel } from '@/api/model'
import { IncentivationDataType } from '@/api/model/incentivationDataType'

type IncentivationData =
  | BinaryIncentivationDataModel
  | ManualInputIncentivationDataModel
  | ScoreIncentivationDataModel
  | null
  | undefined

/**
 * The numeric value plotted / compared for a piece of incentivation data:
 * Score → `score`, ManualInput → `enteredReward`. Binary and empty have no number.
 */
export function numericScore(data: IncentivationData): number | null {
  if (!data) return null
  switch (data.incentivationDataType) {
    case IncentivationDataType.Score:
      return (data as ScoreIncentivationDataModel).score ?? null
    case IncentivationDataType.ManualInput:
      return (data as ManualInputIncentivationDataModel).enteredReward ?? null
    default:
      return null
  }
}

/** Renders the "Score" cell: a number for Score/ManualInput, a check/cross for Binary. */
export function ScoreCell({ data }: { data: IncentivationData }) {
  if (!data) return <span className="text-muted-foreground">—</span>
  if (data.incentivationDataType === IncentivationDataType.Binary) {
    return (data as BinaryIncentivationDataModel).isFulfilled
      ? <Check className="size-4 text-green-600" />
      : <X className="size-4 text-destructive" />
  }
  const value = numericScore(data)
  return <span>{value ?? '—'}</span>
}
